import vocaIsNumeric from "voca/is_numeric";

export function isNumeric(value: string): boolean {
    return vocaIsNumeric(value);
}
